import { Loader, Save } from 'lucide-react';
import React, { useState, useEffect, useRef } from 'react';
import Spacing from '../Spacing';
import { notify } from "../../helpers";
import { updateNpiInformations } from '../../services/easyReferral';
import { Drawer } from 'vaul';

export default function NpiEditModal(props) {
  const {
    reloadData = () => {},
    filter = {},
    editNpiData = {},
    setEditNpiData = () => {},
    editNpiModal = false,
    setEditNpiModal = () => {},
    account_id = "",
    setSpecialistDataLoading = () => {},
    previousScrollPosition = 0,
  } = props;

  const defaultValues = {
    account_id: account_id,
    npi: editNpiData?.npi || null,
    provider_organization_name:  editNpiData?.provider_organization_name || "",
    provider_business_practice_location_address_telephone_number: editNpiData?.provider_business_practice_location_address_telephone_number || "",
    provider_first_line_business_practice_location_address: editNpiData?.provider_first_line_business_practice_location_address || "",
    provider_business_practice_location_address_city_name: editNpiData?.provider_business_practice_location_address_city_name || "",
    provider_business_practice_location_address_state_name: editNpiData?.provider_business_practice_location_address_state_name || "",
    provider_business_practice_location_address_postal_code: editNpiData?.provider_business_practice_location_address_postal_code || "",
    authorized_official_first_name: editNpiData?.authorized_official_first_name || "",
    authorized_official_last_name: editNpiData?.authorized_official_last_name || "",
    authorized_official_middle_name: editNpiData?.authorized_official_middle_name || "",
    authorized_official_telephone_number: editNpiData?.authorized_official_telephone_number || "",
    authorized_official_title_or_position: editNpiData?.authorized_official_title_or_position || "",
    healthcare_provider_taxonomy_code_1: editNpiData?.healthcare_provider_taxonomy_code_1 || "",
    healthcare_provider_taxonomy_code_10: editNpiData?.healthcare_provider_taxonomy_code_10 || "",
    healthcare_provider_taxonomy_code_2: editNpiData?.healthcare_provider_taxonomy_code_2 || "",
    healthcare_provider_taxonomy_code_3: editNpiData?.healthcare_provider_taxonomy_code_3 || "",
    healthcare_provider_taxonomy_code_4: editNpiData?.healthcare_provider_taxonomy_code_4 || "",
    healthcare_provider_taxonomy_code_5: editNpiData?.healthcare_provider_taxonomy_code_5 || "",
    healthcare_provider_taxonomy_code_6: editNpiData?.healthcare_provider_taxonomy_code_6 || "",
    healthcare_provider_taxonomy_code_7: editNpiData?.healthcare_provider_taxonomy_code_7 || "",
    healthcare_provider_taxonomy_code_8: editNpiData?.healthcare_provider_taxonomy_code_8 || "",
    healthcare_provider_taxonomy_code_9: editNpiData?.healthcare_provider_taxonomy_code_9 || "",
    provider_business_mailing_address_city_name: editNpiData?.provider_business_mailing_address_city_name || "",
    provider_business_mailing_address_country_code: editNpiData?.provider_business_mailing_address_country_code || "",
    provider_business_mailing_address_fax_number: editNpiData?.provider_business_mailing_address_fax_number || "",
    provider_business_mailing_address_postal_code: editNpiData?.provider_business_mailing_address_postal_code || "",
    provider_business_mailing_address_state_name: editNpiData?.provider_business_mailing_address_state_name || "",
    provider_business_mailing_address_telephone_number: editNpiData?.provider_business_mailing_address_telephone_number || "",
    provider_business_practice_location_address_country_code: editNpiData?.provider_business_practice_location_address_country_code || "",
    provider_business_practice_location_address_fax_number: editNpiData?.provider_business_practice_location_address_fax_number || "",
    provider_first_line_business_mailing_address: editNpiData?.provider_first_line_business_mailing_address || ""
  }

  const [formData, setFormData] = useState(defaultValues);
  const [updateNpiLoader, setUpdateNpiLoader] = useState(false);
  const dropdownRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      account_id: account_id,
    })
  }, [account_id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUpdateNpiLoader(true);
    
    try {
      const response = await updateNpiInformations(formData);

      if (response?.detail) {
        notify('error', response?.detail);
      } else {
        if(response?.data?.status === 'success'){
          notify("success", response?.data?.message);
          setSpecialistDataLoading(true);
          setFormData(defaultValues);
          reloadData(filter);     
          handleDrawerClose();
        } else {
          notify("error", response?.data?.message);
        }
      }
    } catch (error) { } finally {
      e.target.disabled = false;
      setUpdateNpiLoader(false);
    }
  };

  const handleDrawerClose = () => {
    setEditNpiModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={editNpiModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Edit NPI</Drawer.Title>
            <Drawer.Description className="sr-only">Edit NPI informations</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">
              <div className="docpro_modal" style={{ position: 'unset' }}>
                <div className="docpro_signout_wrap">
                  <form onSubmit={handleSubmit}> 
                    <div className="docpro_signout flex custom-scroll" style={{ minHeight: '100vh', flex: '1 1', flexDirection: 'column' }}>
                      <h2 className="docpro_fs_24 docpro_mb_0">Edit NPI Informations</h2>
                      <Spacing lg="20" sm="20" />

                      <div className='w-full'>
                        <fieldset>
                          <legend><b>Provider Business Practice Informations:</b></legend>
                          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Organization Name <span className="docpro_red_color">*</span></label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_organization_name" required onChange={handleChange} value={formData.provider_organization_name || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Telephone Number <span className="docpro_red_color">*</span></label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_practice_location_address_telephone_number" placeholder='1234567890' required onChange={handleChange} value={formData.provider_business_practice_location_address_telephone_number || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Street Address <span className="docpro_red_color">*</span></label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_first_line_business_practice_location_address" required onChange={handleChange} value={formData.provider_first_line_business_practice_location_address || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">City Name <span className="docpro_red_color">*</span></label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_practice_location_address_city_name" required onChange={handleChange} value={formData.provider_business_practice_location_address_city_name || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">State Name <span className="docpro_red_color">*</span></label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_practice_location_address_state_name" required placeholder='NY' minLength={2} maxLength={2} onChange={handleChange} value={formData.provider_business_practice_location_address_state_name || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Postal Code <span className="docpro_red_color">*</span></label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_practice_location_address_postal_code" required minLength={5} onChange={handleChange} value={formData.provider_business_practice_location_address_postal_code || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Country Code </label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_practice_location_address_country_code" placeholder='US' maxLength={2} onChange={handleChange} value={formData.provider_business_practice_location_address_country_code || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Fax Number </label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_practice_location_address_fax_number" placeholder='1234567890' onChange={handleChange} value={formData.provider_business_practice_location_address_fax_number || ''} />
                            </div>
                          </div>
                        </fieldset>
                        <Spacing lg="25" sm="25" />

                        <fieldset>
                          <legend><b>Authorized Official Informations:</b></legend>
                          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">First Name <span className="docpro_red_color">*</span></label>
                              <input type="text" className="docpro_form_field size_lg" name="authorized_official_first_name" required onChange={handleChange} value={formData.authorized_official_first_name || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Middle Name </label>
                              <input type="text" className="docpro_form_field size_lg" name="authorized_official_middle_name" onChange={handleChange} value={formData.authorized_official_middle_name || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Last Name <span className="docpro_red_color">*</span></label>
                              <input type="text" className="docpro_form_field size_lg" name="authorized_official_last_name" required onChange={handleChange} value={formData.authorized_official_last_name || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Telephone Number </label>
                              <input type="text" className="docpro_form_field size_lg" name="authorized_official_telephone_number" placeholder='1234567890' onChange={handleChange} value={formData.authorized_official_telephone_number || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Title Or Position </label>
                              <input type="text" className="docpro_form_field size_lg" name="authorized_official_title_or_position" onChange={handleChange} value={formData.authorized_official_title_or_position || ''} />
                            </div>
                          </div>
                        </fieldset>
                        <Spacing lg="25" sm="25" />

                        <fieldset>
                          <legend><b>Provider Business Mailing Informations:</b></legend>
                          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Street Address </label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_first_line_business_mailing_address" onChange={handleChange} value={formData.provider_first_line_business_mailing_address || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">City Name </label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_mailing_address_city_name" onChange={handleChange} value={formData.provider_business_mailing_address_city_name || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Country Code </label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_mailing_address_country_code" onChange={handleChange} value={formData.provider_business_mailing_address_country_code || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Fax Number </label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_mailing_address_fax_number" placeholder='1234567890' onChange={handleChange} value={formData.provider_business_mailing_address_fax_number || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Postal Code </label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_mailing_address_postal_code" onChange={handleChange} value={formData.provider_business_mailing_address_postal_code || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">State Name </label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_mailing_address_state_name" onChange={handleChange} value={formData.provider_business_mailing_address_state_name || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Telephone Number </label>
                              <input type="text" className="docpro_form_field size_lg" name="provider_business_mailing_address_telephone_number" placeholder='1234567890' onChange={handleChange} value={formData.provider_business_mailing_address_telephone_number || ''} />
                            </div>
                          </div>
                        </fieldset>
                        <Spacing lg="25" sm="25" />

                        <fieldset>
                          <legend><b>Healthcare Provider Taxonomys:</b></legend>
                          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Taxonomy Code 1 </label>
                              <input type="text" className="docpro_form_field size_lg" name="healthcare_provider_taxonomy_code_1" onChange={handleChange} value={formData.healthcare_provider_taxonomy_code_1 || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Taxonomy Code 2 </label>
                              <input type="text" className="docpro_form_field size_lg" name="healthcare_provider_taxonomy_code_2" onChange={handleChange} value={formData.healthcare_provider_taxonomy_code_2 || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Taxonomy Code 3 </label>
                              <input type="text" className="docpro_form_field size_lg" name="healthcare_provider_taxonomy_code_3" onChange={handleChange} value={formData.healthcare_provider_taxonomy_code_3 || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Taxonomy Code 4 </label>
                              <input type="text" className="docpro_form_field size_lg" name="healthcare_provider_taxonomy_code_4" onChange={handleChange} value={formData.healthcare_provider_taxonomy_code_4 || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Taxonomy Code 5 </label>
                              <input type="text" className="docpro_form_field size_lg" name="healthcare_provider_taxonomy_code_5" onChange={handleChange} value={formData.healthcare_provider_taxonomy_code_5 || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Taxonomy Code 6 </label>
                              <input type="text" className="docpro_form_field size_lg" name="healthcare_provider_taxonomy_code_6" onChange={handleChange} value={formData.healthcare_provider_taxonomy_code_6 || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Taxonomy Code 7 </label>
                              <input type="text" className="docpro_form_field size_lg" name="healthcare_provider_taxonomy_code_7" onChange={handleChange} value={formData.healthcare_provider_taxonomy_code_7 || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Taxonomy Code 8 </label>
                              <input type="text" className="docpro_form_field size_lg" name="healthcare_provider_taxonomy_code_8" onChange={handleChange} value={formData.healthcare_provider_taxonomy_code_8 || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Taxonomy Code 9 </label>
                              <input type="text" className="docpro_form_field size_lg" name="healthcare_provider_taxonomy_code_9" onChange={handleChange} value={formData.healthcare_provider_taxonomy_code_9 || ''} />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">Taxonomy Code 10 </label>
                              <input type="text" className="docpro_form_field size_lg" name="healthcare_provider_taxonomy_code_10" onChange={handleChange} value={formData.healthcare_provider_taxonomy_code_10 || ''} />
                            </div>
                          </div>
                        </fieldset>
                      </div>

                      <div className='text-right'>
                        <Spacing lg="35" sm="35" />
                        <div className='flex items-center docpro_grid_gap_10' style={{ justifyContent: "end" }}>
                          <button
                            type="button"
                            style={{ borderRadius: '4px' }}
                            className="docpro_bordered_btn size_lg docpro_fw_600"
                            onClick={() => {
                              handleDrawerClose();
                              setEditNpiData({});
                            }}
                          >
                            <span>Cancel</span>
                          </button>
                          <button
                            type="submit"
                            style={{ borderRadius: '4px' }}
                            className="docpro_bordered_btn size_lg docpro_fw_600 docpro_white_color docpro_filed_btn"
                            disabled={updateNpiLoader ? true : false}
                          >
                            <Save width={17} height={17} />
                            <span>Submit</span>
                            {updateNpiLoader && (
                              <span className="docpro_loading">
                                <Loader width={20} height={20} />
                              </span>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>

                  <div className="docpro_invoice_btns docpro_hide_print">
                    <button
                      type='button'
                      className="docpro_invoice_btn docpro_color3 close_button"
                      onClick={() => {
                        handleDrawerClose();
                        setEditNpiData({});
                      }}
                    >
                      <span className="docpro_btn_icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                      </span>
                      <span className="docpro_btn_text">Close</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
